import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import GenericUploadFileTable from "../../../componets/GenericUploadFileTable";
import { votersService } from "../../../services/VotersService";
import { changeLang } from "../../../componets/Language/ChangeLang";
import { formatDate } from "../../../config/Config";

const CorrectionView = ({ parentApplication, binaryData, setshowCorrectionDetails, showCorrectionDetails, correctionDetails }) => {
	const [voter, setVoter] = useState(null);
	useEffect(() => {
		fetchVoter();
	}, []);

	const fetchVoter = async () => {
		if (!parentApplication?.idNumber) return;
		try {
			const voterRes = await votersService.getByIDNumber(parentApplication.idNumber);
			setVoter(voterRes);
		} catch (err) {
			console.error("Error fetching voter:", err);
			setVoter(null);
		}
	};

	function BinaryDataView() {
		const safeBinaryData = Array.isArray(binaryData) ? binaryData : [];
		const data = [];

		if (safeBinaryData.length !== 0) {
			for (const item of safeBinaryData) {
				data.push({
					col1: "Type:",
					col2: item?.binaryType,
					col3: item?.binaryData,
					col4: ""
				});
			}
		}

		return (
			<div>
				<GenericUploadFileTable
					header={"Documents"}
					setDocuments={() => {}}
					showAction={false}
					documents={safeBinaryData.map((d) => {
						return {
							...d,
							title: d?.binaryType,
							binaryType: d?.binaryType,
							description: d?.description,
							ext: d?.fileExt
						};
					})}
				/>
				<br />
			</div>
		);
	}

	function CorrectionDetails() {
		let notes = null;
		let app = null;
		let isTransfer = false;

		const application = correctionDetails;

		// Extract correction + set notes
		if (application?.correction != null) {
			notes = application.correction;
		}

		// Determine if amendment OR transfer
		if (application?.amendment) {
			app = application.amendment;
			isTransfer = false;
		} else if (application?.transfer) {
			app = application.transfer;
			isTransfer = true;
		}
		const formatPhone = (phone) => {
			if (!phone?.number) return ""; // No number = return empty string
			return `${phone?.code || ""} ${phone?.number || ""}`.trim();
		};

		const data = [
			{
				col1: "Surname:",
				col2: app?.surname,
				col3: "First Name:",
				col4: app?.name
			},
			{
				col1: "Middle Name:",
				col2: app?.middlename,
				col3: "Gender:",
				col4: app?.gender
			},
			{
				col1: "Disability:",
				col2: app?.disability,
				col3: "Date Of Birth:",
				col4: formatDate(app?.dateOfBirth)
			},
			{
				col1: "Cellphone(1):",
				col2: formatPhone(app?.cellPhone1),
				col3: "Cellphone(2):",
				col4: formatPhone(app?.cellPhone2)
			},
			{
				col3: "Correction Notes:",
				col4: notes?.correctionNotes
			}
		];

		const fromVillage = isTransfer
			? [
					{
						col1: `${changeLang.get("national_delimitation.district")}:`,
						col2: app?.fromVillage?.district,
						col3: `${changeLang.get("national_delimitation.constituency")}:`,
						col4: app?.fromVillage?.constituency
					},
					{
						col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
						col2: app?.fromVillage?.registrationCentre,
						col3: `${changeLang.get("national_delimitation.village")}:`,
						col4: app?.fromVillage?.name
					}
				]
			: [];

		const toVillage = isTransfer
			? [
					{
						col1: `${changeLang.get("national_delimitation.district")}:`,
						col2: app?.toVillage?.district,
						col3: `${changeLang.get("national_delimitation.constituency")}:`,
						col4: app?.toVillage?.constituency
					},
					{
						col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
						col2: app?.toVillage?.registrationCentre,
						col3: `${changeLang.get("national_delimitation.village")}:`,
						col4: app?.toVillage?.name
					}
				]
			: [];

		return (
			<div>
				<br />

				{!isTransfer && (
					<DataTable
						className="remove-border"
						header={"Correction Details"}
						size="small"
						scrollable
						value={data}
						dataKey="id"
						responsiveLayout="scroll"
						style={{ width: "100%" }}
					>
						<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>} />
						<Column className="uppercase" field="col2" style={{ width: "350px" }} />
						<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>} />
						<Column className="uppercase" field="col4" style={{ width: "350px" }} />
					</DataTable>
				)}

				{isTransfer && (
					<>
						<DataTable
							className="remove-border"
							header={"Correction Details"}
							size="small"
							scrollable
							value={data}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>} />
							<Column className="uppercase" field="col2" style={{ width: "350px" }} />
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>} />
							<Column className="uppercase" field="col4" style={{ width: "350px" }} />
						</DataTable>

						<DataTable
							className="remove-border transfer-table-header"
							header={"From Village"}
							size="small"
							scrollable
							value={fromVillage}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>} />
							<Column className="uppercase" field="col2" style={{ width: "350px" }} />
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>} />
							<Column className="uppercase" field="col4" style={{ width: "350px" }} />
						</DataTable>

						<DataTable
							className="remove-border transfer-table-header"
							header={"To Village"}
							size="small"
							scrollable
							value={toVillage}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>} />
							<Column className="uppercase" field="col2" style={{ width: "350px" }} />
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>} />
							<Column className="uppercase" field="col4" style={{ width: "350px" }} />
						</DataTable>
					</>
				)}
			</div>
		);
	}

	function CaptureView() {
		const data = [
			{
				col1: "Captured By:",
				col2: correctionDetails?.createdBy,
				col3: "Captured Date:",
				col4: formatDate(correctionDetails?.createdDate)
			},
			{
				col1: "Device ID:",
				col2: correctionDetails?.component?.deviceID,
				col3: "Serial No:",
				col4: correctionDetails?.component?.serialNo
			}
		];
		return (
			<div>
				<DataTable
					className="remove-border"
					header={`Capture Details`}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function VoterView() {
		var cellphone1;
		var cellphone2;
		var email = "";

		if (voter) {
			for (const contact of Array.isArray(voter?.contactDetails) ? voter.contactDetails : []) {
				if (contact.contactType.contactTypeID === 2) {
					email = contact.contactDetail;
				} else {
					if (contact.contactIndex === 1) {
						cellphone1 = `${contact?.countryCode?.code || ""}${contact.contactDetail}`;
					} else {
						cellphone2 = `${contact?.countryCode?.code || ""}${contact.contactDetail}`;
					}
				}
			}
		}
		const data = [
			{
				col1: "National ID:",
				col2: voter?.idNumber,
				col3: "Registration Number:",
				col4: voter?.registrationNumber
			},
			{
				col1: "Surname:",
				col2: voter?.surname,
				col3: "Firstname:",
				col4: voter?.firstname
			},
			{
				col1: "Middle Name:",
				col2: voter?.middlename,
				col3: "Date Of Birth:",
				col4: voter?.dateOfBirth?.split("T")[0]
			},
			{
				col1: "Gender",
				col2: voter?.gender,
				col3: "Disability:",
				col4: voter?.disability
			},
			{
				col1: "Email:",
				col2: email,
				col3: "Cellphone(1):",
				col4: cellphone1
			},
			{
				col1: "Cellphone(2):",
				col2: cellphone2,
				col3: "Eligibility Status:",
				col4: voter?.eligibleStatus == "Y" ? "Eligible" : "Not Eligible"
			},
			{
				col1: "Deceased:",
				col2: voter?.deceased == "Y" ? "Yes" : "No",
				col3: "",
				col4: ""
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={"Original Details"}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
			</div>
		);
	}

	return (
		<Dialog
			visible={showCorrectionDetails}
			header={"Correction Details"}
			style={{ width: "80vw", height: "80vh" }}
			footer={
				<div>
					<Button
						icon="pi pi-times-circle"
						label="Close"
						onClick={() => {
							setshowCorrectionDetails(false);
						}}
						className="p-button-danger"
					/>
				</div>
			}
			onHide={() => {
				setshowCorrectionDetails(false);
			}}
		>
			<VoterView />
			<CorrectionDetails />
			<BinaryDataView />
			<CaptureView />
		</Dialog>
	);
};

export default CorrectionView;
